export default __webpack_public_path__ + "static/media/hero-blog.d0c3edfc.svg";